/**
 * Wraps a sanitized OneNote page body into a standalone HTML document
 * (ARCHITECTURE.md §7: `onenote/<notebook>/<section>/<page>.html`).
 *
 * Pure and dependency-free — the sanitizing/parsing step (sanitize.ts) needs
 * a DOM and lives separately so this part stays unit-testable under plain
 * Node, the same split every module here uses between DOM-dependent and pure
 * logic.
 */

function escapeHtml(text: string): string {
    return text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}

export function renderPage(title: string, bodyHtml: string): string {
    return `<!doctype html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>${escapeHtml(title)}</title>
<style>
    body { font: 15px/1.5 system-ui, -apple-system, "Segoe UI", sans-serif; max-width: 46rem; margin: 0 auto; padding: 1.5rem 1rem 4rem; color: #1b1f24; }
    h1 { font-size: 1.3rem; }
    .page-body { position: relative; }
    .page-body img { max-width: 100%; border-radius: 4px; }
    @media (prefers-color-scheme: dark) {
        body { background: #16191d; color: #e6e9ed; }
    }
</style>
</head>
<body>
<h1>${escapeHtml(title)}</h1>
<div class="page-body">${bodyHtml}</div>
</body>
</html>
`;
}
